/* eslint-disable */
import React from "react";
import { Box, Checkbox, IconButton, Tooltip, Typography, Switch } from "@mui/material";
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import CircleIcon from '@mui/icons-material/Circle';
import { styled } from '@mui/styles';
import { createTheme } from '@mui/material/styles';
import airSvg from '../../../assets/images/airSvg.svg';
import groundSvg from '../../../assets/images/sedan_black_small.svg';
import completedSvg from '../../../assets/images/completedSvg.svg';
import notCompletedSvg from '../../../assets/images/notCompletedSvg.svg';
import rejectSvg from '../../../assets/images/rejectSvg.svg';
import notRejectSvg from '../../../assets/images/notRejectSvg.svg';
import DraftCombineTransportationAccordianCard from "../../../modules/Transportation/DraftCombineTransportation/transportAccordianCard";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { FULL_PERMISSION } from '../../../constants/Constant';
import Helper from "../../../utility/helper";
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import FlightLandIcon from '@mui/icons-material/FlightLand';
const theme = createTheme();

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(() => ({
    // border: `1px solid ${theme.palette.divider}`,
    zIndex: 0,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
    borderRadius: theme.spacing(1),
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon />}
        {...props}
    />
))(() => ({
    //backgroundColor: '#f5f5f5',
    //flexDirection: 'row-reverse',
    padding: theme.spacing(1),
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(180deg)',
    },
    '& .MuiAccordionSummary-content': {
        margin: theme.spacing(0),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(() => ({
    padding: theme.spacing(0, 2, 1, 2),
    // borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

const CombineTransportRow = (props) => {
    const { classes, item, index } = props;
    const actData = item.actualData;
    const firstword=actData.participant.split(' ')[0];
    // console.log('item -> ', item);
    return (
        <Accordion expanded={item.expanded}>
            <AccordionSummary
                expandIcon={
                    <Tooltip title="Info" aria-label="info">
                        <ExpandMoreIcon
                            onClick={() => props.onToggleChange(item, index)}
                            sx={{ cursor: 'pointer' }}
                        />
                    </Tooltip>
                }
                aria-controls="panel1a-content"
                id="panel1a-header">
                <Box
                    sx={{
                        display: 'grid',
                        maxWidth: '100%',
                        width: '100%',
                        alignItems: 'center',
                        gridTemplateColumns: {
                            xs: 'repeat(2,1fr)',
                            md: 'minmax(0, 0.5fr) minmax(0, 3fr) repeat(6, 1fr)',
                        },
                        flexDirection: 'row',
                        textAlign: 'left',
                        justifyContent: 'left',
                        alignItems: 'left',
                        gap: '20px',
                    }}>
                    <Box
                        sx={{
                            width: '5%',
                            flexBasis: '5%',
                            flexGrow: 1,
                        }}>
                        <Checkbox
                            inputProps={{
                                'aria-label': 'Combine Transport',
                            }}
                            checked={item.selected ? item.selected : false}
                            onChange={(event) =>
                                props.onCheckSelect(event, index)
                            }
                            // color="secondary"
                            value={actData.draftCombineTransportID}
                        />
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'left',
                            alignItems: 'start',
                            width: '100%',
                            flexBasis: '30%',
                            flexGrow: 1,
                        }}>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'row',
                            }}>
                            {actData.transportType ? (
                                <IconButton>
                                    {actData.transportType === 'ground' ? (
                                        <Box
                                            component="img"
                                            className={classes.transportLogo}
                                            alt="ground"
                                            src={groundSvg}
                                        />
                                    ) : actData.tripInfoType === 'arrival' ? (
                                            <FlightLandIcon color="primary" />
                                        ) : (
                                            <FlightTakeoffIcon color="primary" />
                                    )}
                                </IconButton>
                            ) : null}

                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={14}
                                fontWeight={400}>
                                {actData.participant.includes('DELETED') ? (
                                    <span
                                        style={{
                                            color:
                                                firstword === 'DELETED'
                                                    ? 'red'
                                                    : 'inherit',
                                        }}>
                                        {`${firstword} `}
                                        <span style={{ color: '#333' }}>
                                            {actData.participant
                                                .split(' ')
                                                .slice(1)}
                                        </span>
                                    </span>
                                ) : (
                                    <span>{actData.participant}</span>
                                )}
                                <Typography
                                    fontSize={11}
                                    sx={{
                                        wordBreak: 'break-word',
                                    }}>
                                    <a href={`mailto:${actData.email}`}>
                                        {' '}
                                        {actData.email}{' '}
                                    </a>
                                </Typography>
                                {actData.transportType == 'air' ? (
                                    <Typography
                                        fontSize={11}
                                        sx={{
                                            wordBreak: 'break-word',
                                        }}>
                                        {`Event ${
                                            actData.tripInfoType == 'arrival'
                                                ? 'Arrival'
                                                : 'Departure'
                                        }`}
                                    </Typography>
                                ) : null}
                            </Typography>
                        </Box>
                    </Box>
                    {/* <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'left',
                            flexDirection: 'column',
                            alignItems: 'start',
                            width: '15%',
                            flexBasis: '15%',
                            flexGrow: 1,
                        }}>

                        <Typography
                            variant="h4"
                            // flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            color="primary">
                            Person Name
                        </Typography>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={14}
                            fontWeight={400}>
                            <span>{actData.passangerName}</span>
                        </Typography>
                    </Box> */}
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'left',
                            alignItems: 'start',
                            width: '100%',
                            flexBasis: '15%',
                            flexGrow: 1,
                        }}>
                        <Typography
                            variant="h4"
                            // flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            color="primary">
                            Submitted By
                        </Typography>
                        <Typography
                            variant="h4"
                            // flexGrow={1}
                            fontSize={14}
                            fontWeight={400}>
                            <span>{actData.submittedBy}</span>
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'left',
                            alignItems: 'start',
                            width: '100%',
                            flexBasis: '15%',
                            flexGrow: 1,
                        }}>
                        <Typography
                            variant="h4"
                            // flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            color="primary">
                            Submitted Date
                        </Typography>
                        <Typography
                            variant="h4"
                            // flexGrow={1}
                            fontSize={14}
                            fontWeight={400}>
                            <span>{Helper.FormatDateTime(actData.date)}</span>
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: {
                                md: 'center',
                                xs: 'flex-start',
                                sm: 'flex-start',
                                lg: 'center',
                            },
                            alignItems: 'center',
                            width: '100%',
                            flexBasis: '5%',
                            flexGrow: 1,
                        }}>
                        <Tooltip title="Change Log" aria-label="changelog">
                            <IconButton
                                color="primary"
                                onClick={() => props.showHistory(item)}
                                disabled={
                                    item.disableRow != undefined
                                        ? item.disableRow
                                        : false
                                }>
                                <VisibilityOutlinedIcon
                                    fontSize="small"
                                    color={
                                        item.disableRow != undefined
                                            ? 'default'
                                            : 'primary'
                                    }
                                />
                            </IconButton>
                        </Tooltip>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: {
                                md: 'center',
                                xs: 'flex-start',
                                sm: 'flex-start',
                                lg: 'center',
                            },
                            width: '100%',
                            flexBasis: '5%',
                            flexGrow: 1,
                        }}>
                        <Typography
                            variant="h4"
                            // flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            color="primary">
                            Shared
                        </Typography>
                        <Switch
                            disabled={
                                props.modPermission &&
                                props.modPermission == FULL_PERMISSION
                                    ? false
                                    : true
                            }
                            checked={
                                actData.sharedWithVendor != undefined
                                    ? actData.sharedWithVendor
                                    : false
                            }
                            onChange={(e) =>
                                props.onSwitchToggle(e, index, item)
                            }
                            inputProps={{ 'aria-label': 'controlled' }}
                            color={'success'}
                        />
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: {
                                md: 'center',
                                xs: 'flex-start',
                                sm: 'flex-start',
                                lg: 'center',
                            },
                            width: '100%',
                            flexBasis: '10%',
                            flexGrow: 1,
                        }}>
                        <Typography
                            variant="h4"
                            // flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            color="primary">
                            Status
                        </Typography>
                        <Tooltip
                            title={actData.requestStatus == 'Rejected' ? 'Not Approved' : actData.requestStatus}
                            aria-label={actData.requestStatus}>
                            <CircleIcon
                                fontSize="small"
                                style={{
                                    color:
                                        actData.requestStatus == 'Pending'
                                            ? '#F9B811'
                                            : actData.requestStatus ==
                                              'Approved'
                                            ? '#169D3C'
                                            : '#C81020',
                                }}
                            />
                        </Tooltip>
                    </Box>
                    <Box
                        sx={{
                            marginInline: '5px',
                            display: 'flex',
                            flexDirection: 'row-reverse',
                            justifyContent: {
                                md: 'center',
                                xs: 'flex-end',
                                sm: 'flex-end',
                                lg: 'center',
                            },
                            alignItems: 'center',
                            width: '100%',
                            flexBasis: '10%',
                            flexGrow: 1,
                        }}>
                        {props.modPermission &&
                        props.modPermission == FULL_PERMISSION ? (
                            <>
                                <Tooltip title="Edit" aria-label="edit">
                                    <IconButton
                                        color="primary"
                                        onClick={() => props.editRow(item)}>
                                        <EditOutlinedIcon
                                            fontSize="small"
                                            color={'primary'}
                                        />
                                    </IconButton>
                                </Tooltip>
                                {props.hideApprove && (
                                    <Tooltip title="Reject" aria-label="Reject">
                                        <IconButton
                                            color="primary"
                                            onClick={() => {
                                                actData.requestStatus ==
                                                    'Pending' ||
                                                actData.requestStatus ==
                                                    'Approved'
                                                    ? props.onActionClick(
                                                          item,
                                                          index,
                                                          'Reject'
                                                      )
                                                    : props.onPendingAction(
                                                          item,
                                                          index
                                                      );
                                            }}
                                            sx={
                                                actData.requestStatus ==
                                                'Pending'
                                                    ? { cursor: 'pointer' }
                                                    : actData.requestStatus ==
                                                      'Rejected'
                                                    ? { cursor: 'default' }
                                                    : { cursor: 'pointer' }
                                            }>
                                            <Box
                                                component="img"
                                                className={classes.actionIcon}
                                                alt="logo."
                                                src={
                                                    actData.requestStatus ==
                                                    'Pending'
                                                        ? notRejectSvg
                                                        : actData.requestStatus ==
                                                          'Approved'
                                                        ? notRejectSvg
                                                        : rejectSvg
                                                }
                                            />
                                        </IconButton>
                                    </Tooltip>
                                )}
                                {props.hideReject && (
                                    <Tooltip
                                        title="Approve"
                                        aria-label="Approve">
                                        <IconButton
                                            color="primary"
                                            onClick={() => {
                                                actData.requestStatus ==
                                                    'Pending' ||
                                                actData.requestStatus ==
                                                    'Rejected'
                                                    ? props.onActionClick(
                                                          item,
                                                          index,
                                                          'Approve'
                                                      )
                                                    : props.onPendingAction(
                                                          item,
                                                          index
                                                      );
                                            }}
                                            sx={
                                                actData.requestStatus ==
                                                'Pending'
                                                    ? { cursor: 'pointer' }
                                                    : actData.requestStatus ==
                                                      'Approved'
                                                    ? { cursor: 'default' }
                                                    : { cursor: 'pointer' }
                                            }>
                                            <Box
                                                component="img"
                                                className={classes.actionIcon}
                                                alt="logo."
                                                src={
                                                    actData.requestStatus ==
                                                    'Pending'
                                                        ? notCompletedSvg
                                                        : actData.requestStatus ==
                                                          'Approved'
                                                        ? completedSvg
                                                        : notCompletedSvg
                                                }
                                            />
                                        </IconButton>
                                    </Tooltip>
                                )}
                            </>
                        ) : null}
                    </Box>
                </Box>
            </AccordionSummary>
            <AccordionDetails>
                <DraftCombineTransportationAccordianCard
                    classes={classes}
                    item={item}
                    index={index}
                    {...props}
                />
            </AccordionDetails>
        </Accordion>
    );
}

export default CombineTransportRow;